import React from "react";
import { reactLocalStorage } from "reactjs-localstorage";
import { Table } from "react-bootstrap";
import withRouter from "../../../util/WithRouter";
import Constants from "../../../util/Constants";
import ApiUiController from "../../../controller/ApiUiController";
import IndividualSalesReportAPI from "../../../api/IndividualSalesReportAPI";
import ChartComponent from "../FixedReportChart";

class IndividualCallInOutReport extends React.Component {
  constructor(props) {
    super(props);

    // Get direction options from local storage
    const directionOptions = reactLocalStorage.getObject(Constants.Model).call.fields.direction.options;
    this.state = {
      directionData: [],
      directionOptions,
      inApiCall: true,
    };
  }

  componentDidMount() {
    // Fetch call direction data
    IndividualSalesReportAPI.getIndividualCallsInOut(
      this.props.filters,
      this.handleReceivedData,
      this.handleFail
    );
  }

  handleReceivedData = (data) => {
    this.setState({ directionData: data, inApiCall: false });
  };

  handleFail = () => {
    this.setState({ inApiCall: false });
  };

  render() {
    const { directionData, directionOptions, inApiCall } = this.state;

    // Create a dictionary to map direction values to sums
    const directionSums = directionOptions.reduce((acc, option) => {
      acc[option.value] = 0;
      return acc;
    }, {});

    // Populate the direction sums with the actual data
    directionData.forEach(item => {
      if (directionSums.hasOwnProperty(item.direction)) {
        directionSums[item.direction] = item.sum;
      }
    });
    const totalSum = Object.values(directionSums).filter(Boolean).reduce((total, value) => total + value, 0);

    return (
      <ApiUiController inApiCall={inApiCall}>
      <div>
        <h2>Incoming & Outgoing Call Report</h2>
        <hr/>
        <div className="row mt-3 p-2">
        <Table striped bordered hover className="col-md-5">
          <thead>
            <tr>
              <th>Direction</th>
              <th>Total</th>
            </tr>
          </thead>
          <tbody>
            {/* Map through directionOptions and display the corresponding sum for each direction */}
            {directionOptions.map((option, index) => (
              <tr key={index}>
                <td>{option.label}</td>
                <td>{directionSums[option.value]}</td>
              </tr>
            ))}
            {/* Display total sum of incoming and outgoing calls */}
            <tr>
              <td><strong>Total</strong></td>
              <td><strong>{totalSum}</strong></td>
            </tr>
          </tbody>
        </Table>
        <div className="col-md-5">
            {/* Pass only progressSums and progressOptions to ChartComponent */}
            <ChartComponent progressSums={directionSums} progressOptions={directionOptions} type={"pie"}/>
        </div>
      </div>
      </div>
    </ApiUiController>
    );
  }
}

export default withRouter(IndividualCallInOutReport);
